import { ORGANIZATION_ID_FIELD } from "Constants/constants";
import { setDeep } from "Libs/objectAccess";

import type { LoadOrganizationPayloadFulfilled } from "./types";
import type { PayloadAction } from "@reduxjs/toolkit";

export const loadOrganizationHandler = (
  state,
  action: PayloadAction<LoadOrganizationPayloadFulfilled>
) => {
  const { payload } = action;
  state.loading = false;
  state.errors = undefined;
  if (payload) {
    setDeep(
      state,
      ["orgByDescriptionField", payload[ORGANIZATION_ID_FIELD]],
      payload
    );

    setDeep(state, ["data", payload.id], payload);
  }
};
